// extracted by mini-css-extract-plugin
export default {"page":"E2-z","cartModal":"F2-z","checkout":"G2-z","placeholder":"H2-z","account":"I2-z"};